// src/components/InstagramEmbedCard.jsx
import React, { useEffect } from 'react';

const EmbedCard = ({ url }) => {
  useEffect(() => {
    // Reload Instagram embed script
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }
  }, []);

  return (
    <div className="insta-card">
      <blockquote
        className="instagram-media"
        data-instgrm-permalink={url}
        data-instgrm-version="14"
        style={{
          background: '#FFF',
          border: 0,
          borderRadius: '3px',
          boxShadow: '0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)',
          margin: '1px',
          maxWidth: '540px',
          minWidth: '326px',
          padding: 0,
          width: '99.375%',
        }}
      ></blockquote>
    </div>
  );
};

export default EmbedCard;
